<template>
	<div style="width: 100%;">
		<el-form ref="fw_form" :model="form" :rules="rules" label-position="left" label-width="200px"
			style="width: 50%; margin-left: 0%;">
			<el-form-item label="固件版本" prop="version">
				<el-input-number v-model="form.version" :min="1" :max="65535" label="BOOT固件版本号1-65535" :precision="0"></el-input-number>
			</el-form-item>

			<el-form-item label="升级说明" prop="description">
				<el-input type="textarea" v-model="form.description" clearable size="mini" style="width: 90%;" placeholder="升级版本的说明信息"></el-input>
			</el-form-item>
			<el-form-item label="配置字段" prop="pre_config">
				<el-input type="textarea" v-model="form.pre_config" clearable size="mini" style="width: 90%;" placeholder="升级版本的配置字段"></el-input>
			</el-form-item>

			<el-form-item label="支持的硬件版本" prop="hw_vers">
				<el-checkbox-group v-model="form.hw_vers">
					<el-checkbox v-for="hw in hardwares" :key="hw.version" :label="hw.version">
						{{ hw.version }}
					</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			
			<el-form-item label="已保存的固件文件" v-show="file_exist != ''">
				<span>{{ file_exist }}</span>
			</el-form-item>

			<el-form-item label="选择固件文件" prop="upload">
				<el-upload class="upload-demo" ref="upload" :accept="acceptFile()" action="" :file_list="fileList" :auto-upload="false"
						:on-change="fileChange" :on-remove="fileRemove" :http-request="httpRequest">
					<el-button size="small" type="primary">选择文件</el-button>
					<div slot="tip" class="el-upload-tip">只能上传bin文件</div>
				</el-upload>
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="submit" type="primary">{{ upload_btn_text }}</el-button>
		</span>
	</div>

</template>

<script lang="js">
import { uploadBootFW, getHardwares, getBootFWSupports, updateBootFW } from '@/api';

export default {
	data() {
		var validateFile = (rules, value, callback) => {
			if (this.fileList.length < 1) {
				callback(new Error('请选择文件'));
			} else {
				callback()
			}
		}

		return {
			is_details: false,	// true-新增页，false-详情页
			upload_btn_text: '',
			fileList: [],
			file_exist: '',
			hardwares: [],
			form: {
				version: 0,
				description: "",
				pre_config: "",
				hw_vers: [],
				fw_file: []
			},

			rules: {
				version: [
				{required: true, message: '硬件版本号1-65535'}
				],
				description: [
				{required: true, message: '请填写描述信息'}
				],
				hw_vers: [
				{required: true, message: '请选择支持的硬件版本号'}
				],
				fw_file: [
				{required: true, validator: validateFile, message: '请选择上传文件'}
				]
			}
		}
	},
	mounted() {
		// 获取路由参数判断是新增固件页面还是显示固件详情页面
		// const type = this.$route.query.type;
		const boot_fw = this.$route.query.boot_fw;

		// 加载所有的硬件版本号
		getHardwares().then(hardwares => {
			// this.hardwares = hardwares;
			// this.form.hw_vers = hardwares;
			this.hardwares = hardwares;
		});
		
		if (!boot_fw) {
			this.is_details = false;
			this.upload_btn_text = '上传固件';
		}
		else {
			this.is_details = true;
			this.upload_btn_text = '更新固件';
			getBootFWSupports(boot_fw.version).then(res => {
				if (res.status === 200 && res.data.code === 200) {
					const selected_hardwares = res.data.data.hardwares;

					selected_hardwares.forEach(ele => {
						this.form.hw_vers.push(ele.version);
					})
					console.log('获取boot固件'+boot_fw.version+'支持的硬件信息: ', this.hardwares);
				}
			}).catch(error => {
				this.unsupportOperation(error);
			});

			this.form.version = boot_fw.version;
			this.form.description = boot_fw.description;
			this.form.pre_config = boot_fw.pre_config;
			// this.fileList = [boot_fw.url];
			this.file_exist = boot_fw.url;

			console.log('file list', this.fileList);
		}
	},
	methods: {
		submit() {
			this.$refs.fw_form.validate((valid) => {
				if (valid) {
					console.log('fileList = ', this.fileList, 'valid=', valid);
					if (this.fileList.length > 0) {
						this.$refs.upload.submit();
					}
					else {
						// 更新上传的固件信息，不包含固件文件的更新
						var fd = new FormData();
						fd.append('version', this.form.version);
						fd.append('description', this.form.description);
						fd.append('pre_config', this.form.pre_config);
						fd.append('hw_vers', this.form.hw_vers);

						var that = this;
						updateBootFW(fd).then(res => {
							console.log('更新boot固件的结果: ', res);
							if (res.status === 200 && res.data.code === 200) {
								that.open2();
								that.$router.push('/beltbootfirmware');
							} else {
								that.open4(res.data.msg + '[' + res.data.code + ']');
							}
						}).catch(error => {
							this.unsupportOperation(error);
						});
					}
				}
			})
		},
		httpRequest(param) {
			// 只有当选中上传的文件时，才会在submit方法的回调中调用这个方法，因此patch如果没有文件，直接发送patch请求
			console.log('httpRequest param: ', param);
			var fileObj = param.file;
			var fd = new FormData();
			fd.append('version', this.form.version);
			fd.append('description', this.form.description);
			fd.append('pre_config', this.form.pre_config);
			fd.append('fw_file', fileObj);
			fd.append('hw_vers', this.form.hw_vers)
			// var config = {headers: {}, withCredentials: false}

			var that = this;
			if (!this.is_details) {
				// 新增上传固件
				uploadBootFW(fd).then(res => {
					console.log('上传boot固件的结果: ', res);
					if (res.status === 200 && res.data.code === 200) {
						that.open2();
						that.$router.push('/beltbootfirmware');
					} else {
						that.open4(res.data.msg + "[" + res.data.code + "]");
					}
				}).catch(error => {
					this.unsupportOperation(error);
				});
			} else {
				// 更新上传的固件
				updateBootFW(fd).then(res => {
					console.log('更新boot固件的结果: ', res);
					if (res.status === 200 && res.data.code === 200) {
						that.open2();
						that.$router.push('/beltbootfirmware');
					} else {
						that.open4(res.data.msg + '[' + res.data.code + ']');
					}
				}).catch(error => {
					this.unsupportOperation(error);
				});
			}
		},
		open2() {
			this.$message({ message: '上传成功', type: 'success'});
		},

		open4(errStr) {
			this.$message.error('上传失败:' + errStr);
		},

		unsupportOperation(errStr) {
			this.$message.error('该操作当前尚不支持,请等待接口更新后再试', errStr)
		},

		acceptFile() {
			return ".bin";
		},
		fileChange(file, fileList) {
			this.fileList = [file];
			console.log('fileChange:', file, this.fileList);
		},
		fileRemove(file, fileList) {
			this.fileList = [];
			console.log('fileRemove:', file, this.fileList);
		}
	}
}
</script>